export default __webpack_public_path__ + "static/gitkraken_repo-ca80c01222eae4066f9f3b4665e88583.png";